import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = () =>{
const location=useLocation();

useEffect(()=>{
    if(window.fbq){
        window.fbq('track','PageView');
    }
},[location]);
};

export default usePageTracking;